import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./core/components/main/main.routes').then((m) => m.mainRoutes),
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'recover-password',
    loadComponent: () => import('./components/recover-password/recover-password.component').then((m) => m.RecoverPasswordComponent),
  },
  {
    path: 'reset-password/:token/:userID',
    loadComponent: () => import('./components/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'two-factor-auth',
    loadComponent: () => import('./components/two-factor-auth/two-factor-auth.component').then((m) => m.TwoFactorAuthComponent),
  },
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
